import { motion } from "framer-motion";
import type { ReactNode } from "react";

interface BodyProps {
  children: Readonly<ReactNode>;
}

export default function Body({ children }: BodyProps) {
  return (
    <motion.div
      viewport={{ once: true }}
      initial={{ opacity: 0, x: -40 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6 }}
      className="w-full md:w-1/2 space-y-8"
    >
      {children}
    </motion.div>
  );
}
